import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { isPaperThemeActive } from '@/hooks/useThemeFlag';

interface ModalOverlayProps {
  children: ReactNode;
  onBackdropClick?: () => void;
  className?: string;
  cardClassName?: string;
}

export const ModalOverlay = (props: ModalOverlayProps) => {
  const paper = isPaperThemeActive();
  const cardChrome = paper
    ? 'w-full max-w-sm rounded-2xl border border-[var(--hair)] bg-[var(--surface)] p-6 shadow-2xl'
    : 'w-full max-w-sm rounded-2xl border border-white/[0.08] bg-zinc-900 p-6 shadow-2xl';
  const backdropChrome = paper
    ? 'fixed inset-0 flex items-center justify-center bg-[var(--paper)]/70 backdrop-blur-md'
    : 'fixed inset-0 flex items-center justify-center bg-black/60 backdrop-blur-sm';
  return (
    <div
      className={cn(backdropChrome, props.className)}
      onClick={props.onBackdropClick}
      style={paper ? { fontFamily: 'var(--font-sans-paper)' } : undefined}
    >
      <div
        className={cn(cardChrome, props.cardClassName)}
        onClick={props.onBackdropClick ? (e) => e.stopPropagation() : undefined}
      >
        {props.children}
      </div>
    </div>
  );
};
